module.exports = __webpack_public_path__ + "static/media/donation.1b50d2e3.svg";